// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/locale-provider/style/index.css
// module id = 828
// module chunks = 0